import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUsersDetails, updateUserDetails, registerUserDetails, updateUserStatus, verifyPrimaryPhonenumber, deleteUser, verifyFaceRecognition, fetchTrainingCertificateList, verifyStaff, resendConsentLink, updateFaceInUserDetailFLow } from '../../services/user/userService'; // Assuming you have an API function to fetch user data

export const fetchUserDetailsAsync = createAsyncThunk(
  'user/fetchUserDetails',
  async (userId: string, thunkAPI) => {
    const response = await fetchUsersDetails(userId);
    return response;
  }
);

export const updateUserDetailsAsync = createAsyncThunk(
  'user/updateUserDetails',
  async (data: any, thunkAPI) => {
    const response = await updateUserDetails(data);
    return response;
  }
);

export const registerUserDetailsAsync = createAsyncThunk(
  'user/registerUserDetails',
  async (data: any, thunkAPI) => { // Add thunkAPI as the second argument
    const response = await registerUserDetails(data);
    return response;
  }
);

export const updateUserStatusAsync = createAsyncThunk(
  'user/updateUserStatus',
  async (data: any, thunkAPI) => {
    const response = await updateUserStatus(data);
    return response;
  }
);

export const verifyPrimaryPhonenumberAsync = createAsyncThunk(
  'user/verifyPrimaryPhonenumber',
  async (phoneNumber: string, thunkAPI) => {
    const response = await verifyPrimaryPhonenumber(phoneNumber);
    return response;
  }
);

export const deleteUserAsync = createAsyncThunk(
  'user/deleteUser',
  async (userId: string, thunkAPI) => {
    const response = await deleteUser(userId);
    return response;
  }
);

export const  verifyFaceRecognitionAsync = createAsyncThunk(
  'user/verifyFaceRecognition',
  async (data: any, thunkAPI) => {
    const response = await verifyFaceRecognition(data);
    return response;
  }
);


export const fetchTrainingCertificateListAsync = createAsyncThunk(
  'user/fetchTrainingCertificateList',
  async (thunkAPI) => {
    const response = await fetchTrainingCertificateList();
    return response;
  }
);


export const verifyUserAsync = createAsyncThunk(
  'user/verifyStaff',
  async (data: any, thunkAPI) => {
    const response = await verifyStaff(data);
    return response;
  }
);
export const resendConsentLinkAsync = createAsyncThunk(
  'user/resendConsentLink',
  async (userId: string, thunkAPI) => {
    const response = await resendConsentLink(userId);
    return response;
  }
);
export const updateFaceInEditFlowAsync = createAsyncThunk(
  'user/updateFaceInEditFLow',
  async (data: any, thunkAPI) => {
    const response = await updateFaceInUserDetailFLow(data);
    return response;
  }
);
